function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "pedigree-7gen-mor");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "pedigree-7gen-mor",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("rect", {
  id: "hun",
  fill: "#FFDFDF",
  fillRule: "nonzero",
  x: 0,
  y: 35,
  width: 247,
  height: 1612
}), React.createElement("text", {
  id: 1,
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 12.7,
  y: 21
}, "1")), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 10.5,
  y: 11.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 70.5,
  y: 124.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 60.5,
  y: 231.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 50.5,
  y: 431.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 30.5,
  y: 831.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 154.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 70.5,
  y: 326.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 80.5,
  y: 76.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 54.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 99.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 80.5,
  y: 276.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 254.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 299.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 80.5,
  y: 176.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 199.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 354.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 80.5,
  y: 376.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 399.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 70.5,
  y: 524.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 60.5,
  y: 631.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 554.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 70.5,
  y: 726.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 80.5,
  y: 476.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 454.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 499.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 80.5,
  y: 676.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 654.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 699.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 80.5,
  y: 576.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 599.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 754.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 80.5,
  y: 776.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 799.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 70.5,
  y: 924.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 60.5,
  y: 1031.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 50.5,
  y: 1231.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 954.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 70.5,
  y: 1126.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 80.5,
  y: 876.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 854.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 899.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 80.5,
  y: 1076.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 1054.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 1099.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 80.5,
  y: 976.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 999.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 1154.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 80.5,
  y: 1176.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 1199.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 70.5,
  y: 1324.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 60.5,
  y: 1431.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 1354.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 70.5,
  y: 1526.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 80.5,
  y: 1276.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 1254.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 1299.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 80.5,
  y: 1476.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 1454.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 1499.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 80.5,
  y: 1376.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 1399.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 1554.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 80.5,
  y: 1576.5,
  width: 12,
  height: 12
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#848484",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 90.5,
  y: 1599.5,
  width: 12,
  height: 12
}), React.createElement("text", {
  id: "selected-dog-name",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 12,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 27,
  y: 21
}, " Dog  ")), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 13.7,
  y: 21
}, "1")), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 72.7,
  y: 134
}, "5")), React.createElement("text", {
  id: "name-1000",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 87,
  y: 134
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 62.7,
  y: 241
}, "4")), React.createElement("text", {
  id: "name-100",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 77,
  y: 241
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 52.7,
  y: 441
}, "3")), React.createElement("text", {
  id: "name-10",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 67,
  y: 441
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 32.7,
  y: 841
}, "2")), React.createElement("text", {
  id: "name-1",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 47,
  y: 841
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 164
}, "7")), React.createElement("text", {
  id: "name-100010",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 164
})), React.createElement("text", {
  id: "name-1000100",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 154
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 72.7,
  y: 336
}, "5")), React.createElement("text", {
  id: "name-1001",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 87,
  y: 336
})), React.createElement("line", {
  x1: 65.4027778,
  y1: 132.334483,
  x2: 65.4027778,
  y2: 228.665517,
  id: "Line-2-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 65.34375,
  y1: 131.5,
  x2: 67.5,
  y2: 131.5,
  id: "Line-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 55.4027778,
  y1: 238.334483,
  x2: 55.4027778,
  y2: 427.5,
  id: "Line-2-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 55.34375,
  y1: 237.5,
  x2: 57.5,
  y2: 237.5,
  id: "Line-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 35.4027778,
  y1: 438.334483,
  x2: 35.4027778,
  y2: 824.5,
  id: "Line-2-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 35.34375,
  y1: 437.5,
  x2: 46.5,
  y2: 437.5,
  id: "Line-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 82.7,
  y: 86
}, "6")), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 64
}, "7")), React.createElement("text", {
  id: "name-10000",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 97,
  y: 86
})), React.createElement("text", {
  id: "name-100000",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 64
})), React.createElement("text", {
  id: "name-1000000",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 54
})), React.createElement("text", {
  id: "name-1000001",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 74
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 109
}, "7")), React.createElement("text", {
  id: "name-100001",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 109
})), React.createElement("text", {
  id: "name-1000010",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 99
})), React.createElement("text", {
  id: "name-1000011",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 119
})), React.createElement("line", {
  x1: 75.4027778,
  y1: 82.3344828,
  x2: 75.4027778,
  y2: 121.5,
  id: "Line-2-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 75.34375,
  y1: 81.5,
  x2: 77.5,
  y2: 81.5,
  id: "Line-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 82.7,
  y: 286
}, "6")), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 264
}, "7")), React.createElement("text", {
  id: "name-10010",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 97,
  y: 286
})), React.createElement("text", {
  id: "name-100100",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 264
})), React.createElement("text", {
  id: "name-1001000",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 254
})), React.createElement("text", {
  id: "name-1001001",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 274
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 309
}, "7")), React.createElement("text", {
  id: "name-100101",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 309
})), React.createElement("text", {
  id: "name-1001010",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 299
})), React.createElement("text", {
  id: "name-1001011",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 319
})), React.createElement("line", {
  x1: 75.4027778,
  y1: 282.334483,
  x2: 75.4027778,
  y2: 321.5,
  id: "Line-2-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 75.34375,
  y1: 281.5,
  x2: 77.5,
  y2: 281.5,
  id: "Line-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 82.7,
  y: 186
}, "6")), React.createElement("text", {
  id: "name-10001",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 97,
  y: 186
})), React.createElement("text", {
  id: "name-1000101",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 174
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 209
}, "7")), React.createElement("text", {
  id: "name-100011",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 209
})), React.createElement("text", {
  id: "name-1000110",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 199
})), React.createElement("text", {
  id: "name-1000111",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 219
})), React.createElement("line", {
  x1: 75.4027778,
  y1: 142.334483,
  x2: 75.4027778,
  y2: 181.5,
  id: "Line-2-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 75.34375,
  y1: 182.5,
  x2: 77.5,
  y2: 182.5,
  id: "Line-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 364
}, "7")), React.createElement("text", {
  id: "name-100110",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 364
})), React.createElement("text", {
  id: "name-1001100",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 354
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 82.7,
  y: 386
}, "6")), React.createElement("text", {
  id: "name-10011",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 97,
  y: 386
})), React.createElement("text", {
  id: "name-1001101",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 374
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 409
}, "7")), React.createElement("text", {
  id: "name-100111",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 409
})), React.createElement("text", {
  id: "name-1001110",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 399
})), React.createElement("text", {
  id: "name-1001111",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 419
})), React.createElement("line", {
  x1: 75.4027778,
  y1: 342.334483,
  x2: 75.4027778,
  y2: 381.5,
  id: "Line-2-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 75.34375,
  y1: 382.5,
  x2: 77.5,
  y2: 382.5,
  id: "Line-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 65.4027778,
  y1: 247.5,
  x2: 65.4027778,
  y2: 331.5,
  id: "Line-2-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 65.34375,
  y1: 332.5,
  x2: 67.5,
  y2: 332.5,
  id: "Line-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 72.7,
  y: 534
}, "5")), React.createElement("text", {
  id: "name-1010",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 87,
  y: 534
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 62.7,
  y: 641
}, "4")), React.createElement("text", {
  id: "name-101",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 77,
  y: 641
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 564
}, "7")), React.createElement("text", {
  id: "name-101010",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 564
})), React.createElement("text", {
  id: "name-1010100",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 554
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 72.7,
  y: 736
}, "5")), React.createElement("text", {
  id: "name-1011",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 87,
  y: 736
})), React.createElement("line", {
  x1: 65.34375,
  y1: 531.5,
  x2: 67.5,
  y2: 531.5,
  id: "Line-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 82.7,
  y: 486
}, "6")), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 464
}, "7")), React.createElement("text", {
  id: "name-10100",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 97,
  y: 486
})), React.createElement("text", {
  id: "name-101000",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 464
})), React.createElement("text", {
  id: "name-1010000",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 454
})), React.createElement("text", {
  id: "name-1010001",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 474
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 509
}, "7")), React.createElement("text", {
  id: "name-101001",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 509
})), React.createElement("text", {
  id: "name-1010010",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 499
})), React.createElement("text", {
  id: "name-1010011",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 519
})), React.createElement("line", {
  x1: 75.4027778,
  y1: 482.334483,
  x2: 75.4027778,
  y2: 521.5,
  id: "Line-2-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 75.34375,
  y1: 481.5,
  x2: 77.5,
  y2: 481.5,
  id: "Line-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 82.7,
  y: 686
}, "6")), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 664
}, "7")), React.createElement("text", {
  id: "name-10110",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 97,
  y: 686
})), React.createElement("text", {
  id: "name-101100",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 664
})), React.createElement("text", {
  id: "name-1011000",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 654
})), React.createElement("text", {
  id: "name-1011001",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 674
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 709
}, "7")), React.createElement("text", {
  id: "name-101101",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 709
})), React.createElement("text", {
  id: "name-1011010",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 699
})), React.createElement("text", {
  id: "name-1011011",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 719
})), React.createElement("line", {
  x1: 75.4027778,
  y1: 682.334483,
  x2: 75.4027778,
  y2: 721.5,
  id: "Line-2-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 75.34375,
  y1: 681.5,
  x2: 77.5,
  y2: 681.5,
  id: "Line-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 82.7,
  y: 586
}, "6")), React.createElement("text", {
  id: "name-10101",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 97,
  y: 586
})), React.createElement("text", {
  id: "name-1010101",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 574
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 609
}, "7")), React.createElement("text", {
  id: "name-101011",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 609
})), React.createElement("text", {
  id: "name-1010110",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 599
})), React.createElement("text", {
  id: "name-1010111",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 619
})), React.createElement("line", {
  x1: 75.4027778,
  y1: 542.334483,
  x2: 75.4027778,
  y2: 581.5,
  id: "Line-2-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 75.34375,
  y1: 582.5,
  x2: 77.5,
  y2: 582.5,
  id: "Line-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 764
}, "7")), React.createElement("text", {
  id: "name-101110",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 764
})), React.createElement("text", {
  id: "name-1011100",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 754
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 82.7,
  y: 786
}, "6")), React.createElement("text", {
  id: "name-10111",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 97,
  y: 786
})), React.createElement("text", {
  id: "name-1011101",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 774
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 809
}, "7")), React.createElement("text", {
  id: "name-101111",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 108,
  y: 809
})), React.createElement("text", {
  id: "name-1011110",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 799
})), React.createElement("text", {
  id: "name-1011111",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 819
})), React.createElement("line", {
  x1: 75.4027778,
  y1: 742.334483,
  x2: 75.4027778,
  y2: 781.5,
  id: "Line-2-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 75.34375,
  y1: 782.5,
  x2: 77.5,
  y2: 782.5,
  id: "Line-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 65.4027778,
  y1: 647.5,
  x2: 65.4027778,
  y2: 731.5,
  id: "Line-2-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 65.4027778,
  y1: 532.5,
  x2: 65.5,
  y2: 626.5,
  id: "Line-2-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 65.34375,
  y1: 732.5,
  x2: 67.5,
  y2: 732.5,
  id: "Line-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 55.4027778,
  y1: 447.5,
  x2: 55.4027778,
  y2: 638.5,
  id: "Line-2-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 55.34375,
  y1: 639.5,
  x2: 57.5,
  y2: 639.5,
  id: "Line-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 72.7,
  y: 934
}, "5")), React.createElement("text", {
  id: "name-1100",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 87,
  y: 934
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 62.7,
  y: 1041
}, "4")), React.createElement("text", {
  id: "name-110",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 77,
  y: 1041
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 52.7,
  y: 1241
}, "3")), React.createElement("text", {
  id: "name-11",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 67,
  y: 1241
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 964
}, "7")), React.createElement("text", {
  id: "name-110010",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 964
})), React.createElement("text", {
  id: "name-1100100",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 954
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 72.7,
  y: 1136
}, "5")), React.createElement("text", {
  id: "name-1101",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 87,
  y: 1136
})), React.createElement("line", {
  x1: 65.4027778,
  y1: 932.334483,
  x2: 65.4027778,
  y2: 1028.66552,
  id: "Line-2-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 65.34375,
  y1: 931.5,
  x2: 67.5,
  y2: 931.5,
  id: "Line-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 55.4027778,
  y1: 1038.33448,
  x2: 55.4027778,
  y2: 1227.5,
  id: "Line-2-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 55.34375,
  y1: 1037.5,
  x2: 57.5,
  y2: 1037.5,
  id: "Line-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 35.4027778,
  y1: 1238.33448,
  x2: 35.4027778,
  y2: 848.5,
  id: "Line-2-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 35.34375,
  y1: 1237.5,
  x2: 46.5,
  y2: 1237.5,
  id: "Line-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 82.7,
  y: 886
}, "6")), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 864
}, "7")), React.createElement("text", {
  id: "name-11000",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 97,
  y: 886
})), React.createElement("text", {
  id: "name-110000",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 864
})), React.createElement("text", {
  id: "name-1100000",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 854
})), React.createElement("text", {
  id: "name-1100001",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 874
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 909
}, "7")), React.createElement("text", {
  id: "name-110001",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 909
})), React.createElement("text", {
  id: "name-1100010",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 899
})), React.createElement("text", {
  id: "name-1100011",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 919
})), React.createElement("line", {
  x1: 75.4027778,
  y1: 882.334483,
  x2: 75.4027778,
  y2: 921.5,
  id: "Line-2-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 75.34375,
  y1: 881.5,
  x2: 77.5,
  y2: 881.5,
  id: "Line-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 82.7,
  y: 1086
}, "6")), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 1064
}, "7")), React.createElement("text", {
  id: "name-11010",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 97,
  y: 1086
})), React.createElement("text", {
  id: "name-110100",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 1064
})), React.createElement("text", {
  id: "name-1101000",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 1054
})), React.createElement("text", {
  id: "name-1101001",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 1074
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 1109
}, "7")), React.createElement("text", {
  id: "name-110101",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 1109
})), React.createElement("text", {
  id: "name-1101010",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 1099
})), React.createElement("text", {
  id: "name-1101011",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 1119
})), React.createElement("line", {
  x1: 75.4027778,
  y1: 1082.33448,
  x2: 75.4027778,
  y2: 1121.5,
  id: "Line-2-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 75.34375,
  y1: 1081.5,
  x2: 77.5,
  y2: 1081.5,
  id: "Line-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 82.7,
  y: 986
}, "6")), React.createElement("text", {
  id: "name-11001",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 97,
  y: 986
})), React.createElement("text", {
  id: "name-1100101",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 974
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 1009
}, "7")), React.createElement("text", {
  id: "name-110011",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 1009
})), React.createElement("text", {
  id: "name-1100110",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 999
})), React.createElement("text", {
  id: "name-1100111",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 1019
})), React.createElement("line", {
  x1: 75.4027778,
  y1: 942.334483,
  x2: 75.4027778,
  y2: 981.5,
  id: "Line-2-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 75.34375,
  y1: 982.5,
  x2: 77.5,
  y2: 982.5,
  id: "Line-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 1164
}, "7")), React.createElement("text", {
  id: "name-110110",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 1164
})), React.createElement("text", {
  id: "name-1101100",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 1154
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 82.7,
  y: 1186
}, "6")), React.createElement("text", {
  id: "name-11011",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 97,
  y: 1186
})), React.createElement("text", {
  id: "name-1101101",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 1174
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 1209
}, "7")), React.createElement("text", {
  id: "name-110111",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 1209
})), React.createElement("text", {
  id: "name-1101110",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 1199
})), React.createElement("text", {
  id: "name-1101111",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 1219
})), React.createElement("line", {
  x1: 75.4027778,
  y1: 1142.33448,
  x2: 75.4027778,
  y2: 1181.5,
  id: "Line-2-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 75.34375,
  y1: 1182.5,
  x2: 77.5,
  y2: 1182.5,
  id: "Line-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 65.4027778,
  y1: 1047.5,
  x2: 65.4027778,
  y2: 1131.5,
  id: "Line-2-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 65.34375,
  y1: 1132.5,
  x2: 67.5,
  y2: 1132.5,
  id: "Line-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 72.7,
  y: 1334
}, "5")), React.createElement("text", {
  id: "name-1110",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 87,
  y: 1334
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 62.7,
  y: 1441
}, "4")), React.createElement("text", {
  id: "name-111",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 77,
  y: 1441
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 1364
}, "7")), React.createElement("text", {
  id: "name-111010",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 1364
})), React.createElement("text", {
  id: "name-1110100",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 1354
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 72.7,
  y: 1536
}, "5")), React.createElement("text", {
  id: "name-1111",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 87,
  y: 1536
})), React.createElement("line", {
  x1: 63.5,
  y1: 1331.5,
  x2: 67.5,
  y2: 1331.5,
  id: "Line-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 82.7,
  y: 1286
}, "6")), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 1264
}, "7")), React.createElement("text", {
  id: "name-11100",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 97,
  y: 1286
})), React.createElement("text", {
  id: "name-111000",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 1264
})), React.createElement("text", {
  id: "name-1110000",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 1254
})), React.createElement("text", {
  id: "name-1110001",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 1274
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 1309
}, "7")), React.createElement("text", {
  id: "name-111001",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 1309
})), React.createElement("text", {
  id: "name-1110010",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 1299
})), React.createElement("text", {
  id: "name-1110011",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 1319
})), React.createElement("line", {
  x1: 75.4027778,
  y1: 1282.33448,
  x2: 75.4027778,
  y2: 1321.5,
  id: "Line-2-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 75.34375,
  y1: 1281.5,
  x2: 77.5,
  y2: 1281.5,
  id: "Line-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("g", {
  id: "Group-2",
  transform: "translate(74.000000, 1445.000000)"
}, React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "TitilliumWeb-Bold, Titillium Web",
  fontSize: 10,
  fontWeight: "bold",
  fill: "#848484"
}, React.createElement("tspan", {
  x: 8.7,
  y: 41
}, "6")), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "TitilliumWeb-Bold, Titillium Web",
  fontSize: 10,
  fontWeight: "bold",
  fill: "#848484"
}, React.createElement("tspan", {
  x: 18.7,
  y: 19
}, "7")), React.createElement("text", {
  id: "name-11110",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 23,
  y: 41
})), React.createElement("text", {
  id: "name-111100",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 33,
  y: 19
})), React.createElement("text", {
  id: "name-1111000",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 53,
  y: 9
})), React.createElement("text", {
  id: "name-1111001",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 53,
  y: 29
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "TitilliumWeb-Bold, Titillium Web",
  fontSize: 10,
  fontWeight: "bold",
  fill: "#848484"
}, React.createElement("tspan", {
  x: 18.7,
  y: 64
}, "7")), React.createElement("text", {
  id: "name-111101",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 33,
  y: 64
})), React.createElement("text", {
  id: "name-1111010",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 53,
  y: 54
})), React.createElement("text", {
  id: "name-1111011",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 53,
  y: 74
})), React.createElement("line", {
  x1: 1.40277778,
  y1: 37.3344828,
  x2: 1.40277778,
  y2: 76.5,
  id: "Line-2-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 1.34375,
  y1: 36.5,
  x2: 3.5,
  y2: 36.5,
  id: "Line-Copy",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 82.7,
  y: 1386
}, "6")), React.createElement("text", {
  id: "name-11101",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 97,
  y: 1386
})), React.createElement("text", {
  id: "name-1110101",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 1374
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 1409
}, "7")), React.createElement("text", {
  id: "name-111011",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 1409
})), React.createElement("text", {
  id: "name-1110110",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 1399
})), React.createElement("text", {
  id: "name-1110111",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 1419
})), React.createElement("line", {
  x1: 75.4027778,
  y1: 1342.33448,
  x2: 75.4027778,
  y2: 1381.5,
  id: "Line-2-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 75.34375,
  y1: 1382.5,
  x2: 77.5,
  y2: 1382.5,
  id: "Line-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 1564
}, "7")), React.createElement("text", {
  id: "name-111110",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 1564
})), React.createElement("text", {
  id: "name-1111100",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 1554
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 82.7,
  y: 1586
}, "6")), React.createElement("text", {
  id: "name-11111",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 97,
  y: 1586
})), React.createElement("text", {
  id: "name-1111101",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 1574
})), React.createElement("text", {
  id: "far-title-copy-6",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 10,
  fontWeight: 300,
  fill: "#848484"
}, React.createElement("tspan", {
  x: 92.7,
  y: 1609
}, "7")), React.createElement("text", {
  id: "name-111111",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 9,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 107,
  y: 1609
})), React.createElement("text", {
  id: "name-1111110",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 1599
})), React.createElement("text", {
  id: "name-1111111",
  fontFamily: "Helvetica-Light, Helvetica",
  fontSize: 8,
  fontWeight: 300,
  fill: "#000000"
}, React.createElement("tspan", {
  x: 127,
  y: 1619
})), React.createElement("line", {
  x1: 75.4027778,
  y1: 1542.33448,
  x2: 75.4027778,
  y2: 1581.5,
  id: "Line-2-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 75.34375,
  y1: 1582.5,
  x2: 77.5,
  y2: 1582.5,
  id: "Line-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 65.4027778,
  y1: 1447.5,
  x2: 65.4027778,
  y2: 1531.5,
  id: "Line-2-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 65.34375,
  y1: 1532.5,
  x2: 67.5,
  y2: 1532.5,
  id: "Line-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 55.4027778,
  y1: 1247.5,
  x2: 55.4027778,
  y2: 1438.5,
  id: "Line-2-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 55.34375,
  y1: 1439.5,
  x2: 57.5,
  y2: 1439.5,
  id: "Line-Copy",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 63.25,
  y1: 1331.5,
  x2: 63.25,
  y2: 1426.5,
  id: "Line",
  stroke: "#4783A8",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 14.5,
  y1: 836.5,
  x2: 14.5,
  y2: 39.5,
  id: "Line-2",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}), React.createElement("line", {
  x1: 15.5,
  y1: 836.5,
  x2: 27.5,
  y2: 836.5,
  id: "Line-3",
  stroke: "#A65E5E",
  strokeLinecap: "square",
  fillRule: "nonzero"
}));

var SvgPedigree7GenMor = function SvgPedigree7GenMor(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "200px",
    height: "1626px",
    viewBox: "0 0 200 1626",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPedigree7GenMor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pedigree-7gen-mor.1416e4d9.svg";
export { ForwardRef as ReactComponent };